import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ElementRef,
  HostListener,
} from '@angular/core';
import { currencyFormatter } from 'src/app/utils/currencyFormatter';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
})
export class CheckboxComponent implements OnInit {
  @Input() checkboxData!: any;
  @Input() key!: any;

  @Output() checkboxOutput = new EventEmitter<string>();

  public focused: boolean = false;

  get checked(): boolean {
    return !!this.checkboxData.checked;
  }

  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {}

  @HostListener('focus')
  onFocus(): void {
    this.focused = true;
  }

  @HostListener('blur')
  onBlur(): void {
    this.focused = false;
  }

  selectBox(checkbox: any, value: any): void {
    if (this.checkboxData['offerCount'] === 0) {
      return; // Don't allow selection if disabled
    }

    this.checkboxData.checked = !this.checkboxData.checked;
    checkbox.classList.toggle('selected');
    let obj: any = {
      value: value,
      key: this.key,
      checked: this.checkboxData.checked,
    };
    if (this.checkboxData.type) {
      obj['type'] = this.checkboxData.type;
    }
    this.checkboxOutput.emit(obj);
  }

  onKeydown(event: KeyboardEvent, checkbox: any): void {
    if (event.key === ' ' || event.key === 'Enter') {
      this.selectBox(checkbox, this.checkboxData.value);
      event.preventDefault();
    }
  }

  get labelId(): string {
    return `label-${this.key}-${this.checkboxData.value}`;
  }

  currencyFormatter = currencyFormatter;
}
